module.exports = __webpack_public_path__ + "media/assets/images/landing/ведомство_3-f5f9b554a893af1f034f8f0ee091bca8.png";